/*
 * R1 Format Products — domain filter chips + sort select + result count.
 *
 * Vanilla, no dependencies. Instance-safe: every [data-r1-format-products]
 * section wires up its own state so the section can appear more than once.
 *
 * Behavior:
 *   - Domain chips filter cards by data-domain ("all" shows everything).
 *   - Sort select reorders the rendered cards client-side.
 *   - Count line substitutes [shown]/[total] tokens whenever the filter changes.
 *
 * All products paginate by 250 so the full collection renders on one page.
 */
(function () {
  function initSection(root) {
    if (root.dataset.r1FormatProductsReady === 'true') return;
    root.dataset.r1FormatProductsReady = 'true';

    var chips = Array.prototype.slice.call(root.querySelectorAll('[data-r1-domain-chip]'));
    var sortEl = root.querySelector('[data-r1-fp-sort]');
    var countEl = root.querySelector('[data-r1-fp-count]');
    var grid = root.querySelector('.r1-fp__grid');

    var activeDomain = 'all';

    // Cache original DOM order for "Featured" sort.
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-r1-fp-card]'));
    var originalOrder = cards.slice();

    // ---- Filter ----
    function getVisibleCards() {
      return cards.filter(function (card) {
        if (activeDomain === 'all') return true;
        return (card.getAttribute('data-domain') || '') === activeDomain;
      });
    }

    function applyFilter() {
      var shown = 0;
      cards.forEach(function (card) {
        var domain = card.getAttribute('data-domain') || '';
        var visible = activeDomain === 'all' || domain === activeDomain;
        card.classList.toggle('is-hidden', !visible);
        if (visible) shown++;
      });
      updateCount(shown);
    }

    function updateCount(shown) {
      if (!countEl) return;
      var total = parseInt(countEl.getAttribute('data-total'), 10) || cards.length;
      var text = (countEl.getAttribute('data-label') || '')
        .replace('[shown]', shown)
        .replace('[total]', total);
      countEl.textContent = text;
    }

    // ---- Sort ----
    function applySort(value) {
      var ordered;
      if (value === 'price-asc') {
        ordered = cards.slice().sort(function (a, b) {
          return parseInt(a.getAttribute('data-price'), 10) - parseInt(b.getAttribute('data-price'), 10);
        });
      } else if (value === 'price-desc') {
        ordered = cards.slice().sort(function (a, b) {
          return parseInt(b.getAttribute('data-price'), 10) - parseInt(a.getAttribute('data-price'), 10);
        });
      } else if (value === 'alpha-asc') {
        ordered = cards.slice().sort(function (a, b) {
          var ta = a.getAttribute('data-title') || '';
          var tb = b.getAttribute('data-title') || '';
          return ta.localeCompare(tb);
        });
      } else {
        // Featured: restore server-rendered order
        ordered = originalOrder.slice();
      }
      // Reorder DOM
      ordered.forEach(function (card) {
        grid.appendChild(card);
      });
      // Keep cards array in sync with new DOM order
      cards = ordered;
    }

    // ---- Wire up chips ----
    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        activeDomain = chip.getAttribute('data-domain') || 'all';
        chips.forEach(function (c) {
          c.classList.toggle('is-active', c === chip);
        });
        applyFilter();
      });
    });

    // ---- Wire up sort ----
    if (sortEl) {
      sortEl.addEventListener('change', function () {
        applySort(sortEl.value);
        applyFilter(); // re-apply domain filter after reorder
      });
    }

    // ---- Initial state ----
    applyFilter();
  }

  function initAll() {
    var sections = document.querySelectorAll('[data-r1-format-products]');
    Array.prototype.forEach.call(sections, initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-init when the theme editor injects/updates this section.
  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('[data-r1-format-products]');
    if (section) initSection(section);
  });
})();
